export default __webpack_public_path__ + "static/media/nuget.1e17253b.svg";